/** A positive daily target opts a chart into a fixed scale of twice that target. */
export function dayBarProgress(value: number, dailyGoal: number | null | undefined, relativeMax: number) {
  const goal = dailyGoal != null && Number.isFinite(dailyGoal) && dailyGoal > 0 ? dailyGoal : null
  const count = Number.isFinite(value) ? Math.max(0, value) : 0
  const max = goal == null ? Math.max(1, relativeMax) : goal * 2
  const stars = goal == null || count < goal ? 0 : count >= goal * 2 ? 3 : count >= goal * 1.5 ? 2 : 1
  return {
    goal,
    stars,
    height: Math.max(7, Math.min(100, (count / max) * 100)),
    capped: goal != null && count > max,
  }
}
